import axios from 'axios';
import {
    PageLayout,
    Card,
    CardBody,
    Button,
    CardPlaceholder,
    Permissions,
    useAuthorisationContext,
    useLangContext,
    StringHelpers,
    Variants,
    customToast,
    route,
    API_ENDPOINTS,
} from 'carrier-fe';
import { useState, useEffect } from 'react';

interface MediaPack {
    id: string;
    title: string;
    thumbnail_url: string;
    download_url: string;
}

function MarketingImages() {
    const { getLangPage } = useLangContext();
    const { hasPermissionAccess } = useAuthorisationContext();
    const [mediaPacks, setMediaPacks] = useState<MediaPack[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [lang, setLang] = useState<any>(null);

    useEffect(() => {
        loadLang();
        fetchMediaPacks();
    }, []);

    const loadLang = async () => {
        try {
            const res = await getLangPage('dashboard/marketing_images');
            if (typeof res === 'undefined' || res === null) {
                setLang({});
            } else {
                setLang(res);
                document.title = StringHelpers.title(
                    res?.page?.title ?? 'Marketing Images'
                );
            }
        } catch (err) {
            console.error(err);
        }
    };

    const fetchMediaPacks = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                route(API_ENDPOINTS.DASHBOARD.SUPPORT.MEDIA_PACKS)
            );
            if (response.data && response.data.data && response.data.data.rows) {
                setMediaPacks(response.data.data.rows);
            }
        } catch (error: any) {
             customToast({
                title: error?.response?.data?.message || 'Error loading media packs',
                variant: Variants.Danger,
            });
        } finally {
            setLoading(false);
        }
    };

    if (!hasPermissionAccess(Permissions.SUPPORT_PLATFORM_VIEW)) {
        return null;
    }

    return (
        <PageLayout
            title={StringHelpers.title(lang?.page?.title ?? 'Marketing Images')}
        >
            <div className="row">
                {loading ? (
                    <>
                        <div className="col-12 col-md-3 mb-3">
                            <CardPlaceholder />
                        </div>
                         <div className="col-12 col-md-3 mb-3">
                            <CardPlaceholder />
                        </div>
                         <div className="col-12 col-md-3 mb-3">
                            <CardPlaceholder />
                        </div>
                    </>
                ) : (
                    mediaPacks.map((pack) => (
                        <div key={pack.id} className="col-12 col-md-3 mb-3">
                            <Card noMargin className="h-100">
                                <CardBody className="d-flex flex-column">
                                    {pack.thumbnail_url && (
                                         <div 
                                            className="mb-3"
                                            style={{ 
                                                height: '200px', 
                                                backgroundImage: `url(${pack.thumbnail_url})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    )}
                                    <h5 className="card-title mb-3">{pack.title}</h5>
                                    <div className="mt-auto">
                                        <Button
                                            label={lang?.page?.download_button ?? "Download"}
                                            href={pack.download_url}
                                            variant={Variants.Primary}
                                            externalLink
                                            className="w-100"
                                            disabled={!pack.download_url}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    ))
                )}
                 {!loading && mediaPacks.length === 0 && (
                     <div className="col-12">
                        <p>No marketing images found.</p>
                     </div>
                )}
            </div>
        </PageLayout>
    );
}

export default MarketingImages;
